import { createFileRoute, redirect } from '@tanstack/react-router'
import { LoginPage } from '@/pages/LoginPage'
import { useAuthStore } from '@/store/authStore'

export const Route = createFileRoute('/login')({
  component: LoginPage,
  beforeLoad: () => {
    const token = useAuthStore.getState().token
    if (token) {
      throw redirect({ to: '/' })
    }
  },
})
